import { Component, inject, signal } from '@angular/core';
import { Route } from '../../utils/route';
import { TabsComponent } from "../../components/tabs/tabs.component";
import { EvaluationsTabComponent } from "./evaluations-tab/evaluations-tab.component";
import { RadarChart, RadarChartComponent } from "../../components/radar-chart/radar-chart.component";
import { EvaluationService } from '../../services/evaluation.service';
import { SelectComponent } from '../../components/select/select.component';
import { DictionaryService } from '../../services/dictionary.service';
import { TableResponse } from '../../components/table/table.interface';
import { ExportButtonComponent } from "../../components/export-button/export-button.component";

@Component({
  selector: 'app-evaluations',
  imports: [TabsComponent, EvaluationsTabComponent, RadarChartComponent, SelectComponent, ExportButtonComponent],
  templateUrl: './evaluations.component.html',
  styleUrl: './evaluations.component.scss',
})
export class EvaluationsComponent extends Route {
  dictionaryService = inject(DictionaryService);
  evaluationsService = inject(EvaluationService);
  data: RadarChart = {};
  teamMembers: string[] = [];

  isLoading = signal<boolean>(true);
  exportLoading = signal<boolean>(false);

  constructor() {
    super();
    this.evaluationsService.getTeamEvaluation().subscribe((res) => {
      this.data = this.extractTeamEvaluation(res);
      this.teamMembers = res.data.filters?.['User']!;
      this.isLoading.set(false);
    });
  }

  changeSelectedUsers = (users: string[]) => {
    console.log(users)
    if (!users.length) {
      this.data = {}
    } else {
      this.evaluationsService.getTeamEvaluation(users).subscribe((res) => {
        this.data = this.extractTeamEvaluation(res);
      });
    }
  }

  private extractTeamEvaluation = (res: TableResponse): RadarChart => {
    return Object.fromEntries(
      Object.entries(res.data.rows[0]).filter(([key]) => key !== 'Date').map(([key, value]) => [key, Number(value)]),
    ) as RadarChart;
  }

  exportAll() {
    this.exportLoading.set(true);
    this.evaluationsService.getTeamEvaluationReport().subscribe({
      next: (url) => {
        window.open(url, '_blank');
      },
      error: (err) => {
        console.error(err)
      },

      complete: () => {
        this.exportLoading.set(false);
      }
    })
  }
}
